import React from "react";
import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIndiaStats } from "./indiaSlice";
import { fetchStats } from "./indiaSlice";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./india.module.css";

function India() {
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    dispatch(fetchStats());
  }, [dispatch]);

  const data = useSelector(selectIndiaStats);

  if (data.error) {
    return <div>{data.error}</div>;
  }

  if (data.isLoading) {
    return (
      <div className="loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      <h1 className={styles.blu}>Stats for India</h1>
      <div className={styles.textclr}>
        Active Cases: {data.activeCases.toLocaleString()}&nbsp; Recovered:{" "}
        {data.recovered.toLocaleString()}&nbsp; Deaths:{" "}
        {data.deaths.toLocaleString()}&nbsp;
      </div>
      <br></br>
      <hr></hr>
      {data.regionData.map((x) => (
        <div key={x.region}>
          <div className={styles.textclr}>
            <h2>{x.region}</h2>
            <div>Total infected: {x.totalInfected.toLocaleString()}</div>
            <div>Recovered: {x.recovered.toLocaleString()}</div>
            <div>Deaths: {x.deceased.toLocaleString()}</div>
            <div>New Deaths: {x.newDeceased.toLocaleString()}</div>
          </div>
          <hr />
        </div>
      ))}
    </div>
  );
}

export default India;
